import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    boxContainer: {
        width: "100%",
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
        padding: "20px 30px 0",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    buttonsContainer: {
        width: "100%",
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        padding: "15px 30px",
        display: "flex",
        justifyContent: "flex-end",
    },
    addButton: {
        "&.MuiButton-root": {
            background: theme.palette.info.main,
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.main,
            marginLeft: "15px",
        },
        "&.MuiButton-root:hover": {
            background: theme.palette.info.main,
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    icon: {
        marginRight: "8px",
        fontSize: "22px !important",
    },
}));
